import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { Layout, Form, Input, Button, Typography } from 'antd';
import { UserContext } from '../UserContext';
import '../Login/Login.css'
import axios from 'axios';

const {Content} = Layout
const {Title} = Typography

const Register = () => {
  const {setUser} = useContext(UserContext)
  const [input, setInput] = useState({
    name : "",
    email : "",
    password: ""
  })

  const onChange = (e) => {
    const name = e.target.name
    const value = e.target.value
    
    setInput({
      ...input,
      [name] : value
    })
  }

  const onSubmit = () => {
    axios.post("https://backendexample.sanbersy.com/api/register", {
      name : input.name,
      email : input.email,
      password : input.password
    }).then((res) => {
      const result = res.data
      const data = {
        name : result.user.name,
        isLogged : true, 
        token: result.token
      }
      setUser(data)
      localStorage.setItem('user', JSON.stringify(data) )
    }).catch((err) => {
      alert(JSON.stringify(err.response.data))
    })
  }

  return (
    <Content className="site-layout">
      <div id="login-form">
        <Form
        name="basic"
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 12 }}
        initialValues={{ remember: true }}
        onFinish={onSubmit}
        >
          <Title level={2}>
            Register
          </Title>
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: 'Please input your name!' }]}
          >
            <Input name="name" onChange={onChange} />
          </Form.Item>

          <Form.Item
            label="Email"
            name="email"
            rules={[{ required: true, message: 'Please input your email!' }]}
          >
            <Input name="email" onChange={onChange} />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password name="password" onChange={onChange}/>
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 5, span: 6 }}>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
          
          <Link to="/login">
            <span className="create-or-log">Already Have Account? Login now!</span>
          </Link>
        </Form>

      </div>
    </Content>
  )
}

export default Register